import { SUBSCRIPTION } from "../constants";

const initialState = {
  limit: 20,
  offset: 0,
  total: 0,
  query: "",
  typeFilter: null,
  subscriptions: [],
  subscription: null,
  isLoadingGetSubscription: false,
  isLoadingGetSubscriptions: false,
  isLoadingUpdateSubscription: false,
  isLoadingDeleteSubscription: false,
  isLoadingCreateSubscription: false,
  error: null,
};

const subscriptionsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SUBSCRIPTION.ADD_PATIENT_SUBSCRIPTION:
      return {
        ...state,
      };
    case SUBSCRIPTION.ADD_PATIENT_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case SUBSCRIPTION.ADD_PATIENT_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case SUBSCRIPTION.REMOVE_PATIENT_SUBSCRIPTION:
      return {
        ...state,
      };
    case SUBSCRIPTION.REMOVE_PATIENT_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case SUBSCRIPTION.REMOVE_PATIENT_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case SUBSCRIPTION.GET_SUBSCRIPTION:
      return {
        ...state,
        isLoadingGetSubscription: true,
      };
    case SUBSCRIPTION.GET_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        isLoadingGetSubscription: false,
        error: action.payload,
      };
    case SUBSCRIPTION.GET_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        isLoadingGetSubscription: false,
        subscription: action.payload,
        error: null,
      };
    case SUBSCRIPTION.GET_SUBSCRIPTIONS:
      return {
        ...state,
        isLoadingGetSubscriptions: true,
      };
    case SUBSCRIPTION.GET_SUBSCRIPTIONS_FAILURE:
      return {
        ...state,
        isLoadingGetSubscriptions: false,
        error: action.payload,
      };
    case SUBSCRIPTION.GET_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        isLoadingGetSubscriptions: false,
        subscriptions: action.payload.data,
        total: action.payload.total,
        error: null,
      };
    case SUBSCRIPTION.CREATE_SUBSCRIPTION:
      return {
        ...state,
        isLoadingCreateSubscription: true,
      };
    case SUBSCRIPTION.CREATE_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        isLoadingCreateSubscription: false,
        error: action.payload,
      };
    case SUBSCRIPTION.CREATE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        isLoadingCreateSubscription: false,
        subscription: action.payload,
        error: null,
      };
    case SUBSCRIPTION.UPDATE_SUBSCRIPTION:
      return {
        ...state,
        isLoadingUpdateSubscription: true,
      };
    case SUBSCRIPTION.UPDATE_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        isLoadingUpdateSubscription: false,
        error: action.payload,
      };
    case SUBSCRIPTION.UPDATE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        isLoadingUpdateSubscription: false,
        subscription: action.payload,
        error: null,
      };
    case SUBSCRIPTION.DELETE_SUBSCRIPTION:
      return {
        ...state,
        isLoadingDeleteSubscription: true,
      };
    case SUBSCRIPTION.DELETE_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        isLoadingDeleteSubscription: false,
        error: action.payload,
      };
    case SUBSCRIPTION.DELETE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        isLoadingDeleteSubscription: false,
        error: null,
      };
    case SUBSCRIPTION.SET_OFFSET:
      return {
        ...state,
        offset: action.payload,
      };
    case SUBSCRIPTION.SET_QUERY:
      return {
        ...state,
        query: action.payload,
        offset: 0,
      };
    case SUBSCRIPTION.SET_TYPE_FILTER:
      return {
        ...state,
        typeFilter: action.payload,
        offset: 0,
      };
    case SUBSCRIPTION.CLEAN_SUBSCRIPTION:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default subscriptionsReducer;
